class PinchZoom extends HTMLElement {
  constructor() {
    super();
    this._inner = document.createElement("div");
    this._inner.classList.add("pinch-zoom-inner");
    this._inner.append(...this.children);
    this.appendChild(this._inner);

    this._scale = 1;
    this._startScale = 1;
    this._startDistance = 0;

    this._translateX = 0;
    this._translateY = 0;
    this._startX = 0;
    this._startY = 0;

    this._isPanning = false;

    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);
  }

  connectedCallback() {
    this.addEventListener("touchstart", this._onTouchStart, { passive: false });
    this.addEventListener("touchmove", this._onTouchMove, { passive: false });
    this.addEventListener("touchend", this._onTouchEnd);
    this.addEventListener("touchcancel", this._onTouchEnd);
  }

  disconnectedCallback() {
    this.removeEventListener("touchstart", this._onTouchStart);
    this.removeEventListener("touchmove", this._onTouchMove);
    this.removeEventListener("touchend", this._onTouchEnd);
    this.removeEventListener("touchcancel", this._onTouchEnd);
  }

  _getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  _updateTransform() {
    this._inner.style.transform = `scale(${this._scale}) translate(${
      this._translateX / this._scale
    }px, ${this._translateY / this._scale}px)`;
  }

  _onTouchStart(e) {
    if (e.touches.length === 2) {
      this._startDistance = this._getDistance(e.touches);
      this._startScale = this._scale;
      this._inner.style.transition = "none";
    } else if (e.touches.length === 1 && this._scale > 1.01) {
      this._isPanning = true;
      this._startX = e.touches[0].clientX - this._translateX;
      this._startY = e.touches[0].clientY - this._translateY;
      this._inner.style.transition = "none";
      e.preventDefault(); // block scroll only if zoomed
    }
  }

  _onTouchMove(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      const newDistance = this._getDistance(e.touches);
      const scaleChange = newDistance / this._startDistance;
      this._scale = Math.min(Math.max(1, this._startScale * scaleChange), 4);
      this._updateTransform();
    } else if (this._isPanning && e.touches.length === 1) {
      e.preventDefault();
      this._translateX = e.touches[0].clientX - this._startX;
      this._translateY = e.touches[0].clientY - this._startY;
      this._updateTransform();
    }
  }

  _onTouchEnd() {
    if (this._scale <= 1.01) {
      this._scale = 1;
      this._translateX = 0;
      this._translateY = 0;
      this._inner.style.transition = "transform 0.25s ease";
      this._updateTransform();
    }
    this._isPanning = false;
  }
}

customElements.define("pinch-zoom", PinchZoom);
